import { render, staticRenderFns } from "./CreateDashboard.vue?vue&type=template&id=6edaaffc&scoped=true"
import script from "./CreateDashboard.vue?vue&type=script&lang=js"
export * from "./CreateDashboard.vue?vue&type=script&lang=js"
import style0 from "./CreateDashboard.vue?vue&type=style&index=0&id=6edaaffc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edaaffc",
  null
  
)

export default component.exports